export class TextValueLabel {
    text: string;
    value:any;
    inputData?:any;
    constructor(text:string,value:any,inputData?:any) {
        this.text = text;
        this.value = value;
        this.inputData = inputData;
    }
}